import React, { useEffect, useState } from "react"
import { GET_PurchaseOrderDetail } from "helpers/url_helper"
import { get } from "helpers/api_helper"
import { useParams } from "react-router-dom"
import "./PurchaseOrder.css" // Ensure you have custom CSS for styling

const PurchaseOrderPdf = () => {
  const [data, setData] = useState(null)
  const { id } = useParams()

  function numberToWords(num) {
    if (num === 0) return "Zero only" // Output 'Zero only' for 0

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ]
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ]

    function convertToWords(n) {
      if (n < 20) return ones[n]
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "")
      if (n < 1000)
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " and " + convertToWords(n % 100) : "")
        )
      if (n < 100000)
        return (
          convertToWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + convertToWords(n % 1000) : "")
        )
      if (n < 10000000)
        return (
          convertToWords(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + convertToWords(n % 100000) : "")
        )
      if (n < 1000000000)
        return (
          convertToWords(Math.floor(n / 10000000)) +
          " Crore" +
          (n % 10000000 ? " " + convertToWords(n % 10000000) : "")
        )

      return "Number too large"
    }

    const [wholePart, fractionalPart] = num.toString().split(".")

    let words = convertToWords(parseInt(wholePart)) // Convert the whole part

    return words + " only" // Add 'only' at the end for clarity
  }

  const calculateTaxes = orderItems => {
    let subtotal = 0
    let taxes = {}

    orderItems.forEach(item => {
      const taxableAmount = parseFloat(item.taxable_amount)
      const taxRate = parseFloat(item?.tax?.rate)

      // if (taxRate === 0) return

      const halfRate = taxRate / 2

      if (!taxes[taxRate]) {
        taxes[taxRate] = {
          sgst: 0,
          cgst: 0,
        }
      }

      taxes[taxRate].sgst += (taxableAmount * halfRate) / 100
      taxes[taxRate].cgst += (taxableAmount * halfRate) / 100

      subtotal += taxableAmount
    })

    let totalTax = 0
    Object.values(taxes).forEach(tax => {
      totalTax += tax.sgst + tax.cgst
    })

    const total = subtotal + totalTax

    return {
      subtotal,
      taxes,
      totalTax,
      total,
    }
  }

  useEffect(() => {
    get(GET_PurchaseOrderDetail + id)
      .then(response => {
        setData(response.data)
      })
      .catch(error => console.log(error))
  }, [id])

  // const generatePDF = () => {
  //   const input = document.querySelector(".purchase-order")

  //   if (!input) {
  //     console.error("The element with class 'purchase-order' was not found.")
  //     return
  //   }

  //   const pdfOptions = {
  //     margin: [5, 20, 20, 0],
  //     filename: "purchase_order.pdf",
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { scale: 2, useCORS: true },
  //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //   }

  //   html2pdf()
  //     .from(input)
  //     .set(pdfOptions)
  //     .toPdf()
  //     .get("pdf")
  //     .then(pdf => {
  //       const totalPages = pdf.internal.getNumberOfPages()
  //       pdf.setFontSize(10) // Set font size for footer

  //       // Add footer to each page
  //       for (let i = 1; i <= totalPages; i++) {
  //         pdf.setPage(i)
  //         const footerText = `Page ${i} of ${totalPages}`
  //         pdf.text(
  //           footerText,
  //           pdf.internal.pageSize.width - 20,
  //           pdf.internal.pageSize.height - 10,
  //           { align: "right" }
  //         )
  //       }

  //       // Save the PDF
  //       pdf.save("purchase_order.pdf")
  //     })
  //     .catch(error => {
  //       console.error("Error generating PDF:", error)
  //     })
  // }

  useEffect(() => {
    const handleBeforePrint = () => {
      const printContent = document.querySelectorAll(".purchase-order")
      const totalPages = printContent.length

      printContent.forEach((content, index) => {
        console.log("Current purchase order content:", content)

        const footer = content.querySelector(".page-number")
        if (footer) {
          footer.innerHTML = `Page ${index + 1} of ${totalPages}`
        } else {
          console.error("No .page-number found in:", content)
        }
      })
    }

    // Attach the event handler for before printing
    window.addEventListener("beforeprint", handleBeforePrint)

    // Cleanup event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint)
    }
  }, [])

  const generatePDF = () => {
    const input = document.querySelector(".purchase-order")

    if (!input) {
      console.error("The element with class 'purchase-order' was not found.")
      return
    }

    window.print()
  }

  if (!data) return <div>Loading...</div>

  const billingAddresss = data.organization.addresses.find(
    address => address.type === "billing"
  )

  // Format the address string
  const formattedAddress = billingAddresss
    ? `Reg. Off.: ${billingAddresss.address_line_1}, ${billingAddresss.address_line_2}, ${billingAddresss.city?.city_name}-${billingAddresss.zip_code}`
    : "Address not available"

  const {
    contact = {},
    purchase_order_no,
    purchase_order_date,
    subtotal,
    packaging_charges,
    total_tax,
    total,
    order_item = [],
    organization = {},
    documentation_charges,
    forwarding_charges,
    freight_charges,
    discount,
    tds_amount,
  } = data

  const billingAddress =
    organization.addresses?.find(addr => addr.type === "billing") || {}
  const shippingAddress =
    organization.addresses?.find(addr => addr.type === "shipping") || {}

  // Calculate taxes
  const {
    subtotal: calcSubtotal,
    taxes,
    totalTax,
    total: calcTotal,
  } = calculateTaxes(data.order_item)

  const totalQuantitySum = order_item.reduce((total, item) => {
    return (
      total +
      item.expected_delivery_date_and_qty?.reduce(
        (subTotal, schedule) => subTotal + parseFloat(schedule.quantity),
        0
      )
    )
  }, 0)

  return (
    <div>
      <div className="pdf-button-container">
        <button className="btn btn-primary" type="submit" onClick={generatePDF}>
          Generate PDF
        </button>
      </div>
      <div id="purchase-order" className="purchase-order">
        <div className="header">
          <div className="header-center">
            <div className="header-info">
              <h2>{organization.display_name}</h2>
              <h3>future sense</h3>
              <h2>PURCHASE ORDER</h2>
            </div>
          </div>
        </div>

        <div className="details-section">
          {/* <!-- Invoice To Section --> */}
          <div className="invoice-to">
            <h3>Invoice To ,</h3>
            <h3 className="mb-3">{organization.display_name}</h3>
            <h3>Invoice Address:</h3>
            <p>
              {billingAddress.address_line_1}, {billingAddress.address_line_2},{" "}
              {billingAddress.address_line_3}
            </p>
            <p>
              {billingAddress.city?.city_name},{" "}
              {billingAddress.state?.state_name} - {billingAddress.zip_code}
            </p>
            <p>GST No.: {organization.gstn}</p>
            <p>Tel No.: {organization.phone}</p>
            <p>Email ID: {organization.email}</p>
            <h3 className="mt-3">Delivery Address:</h3>
            <p>
              {shippingAddress.address_line_1}, {shippingAddress.address_line_2}
              ,{shippingAddress.address_line_3}
            </p>
            <p>
              {" "}
              {shippingAddress.city?.city_name},{" "}
              {shippingAddress.state?.state_name} - {shippingAddress.zip_code}
            </p>
          </div>

          {/* <!-- Order Details Section --> */}
          <div className="order-details">
            <table className="order-details-table">
              <tbody >
                <tr>
                  <td>
                    <h5>
                      Order No.
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                    </h5>
                  </td>
                  <td>
                    <h5>{purchase_order_no}</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>
                      Order Date
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
                    </h5>
                  </td>
                  <td>
                    <h5>{new Date(purchase_order_date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      }).replace(/ (\w{3}) /, ' $1, ')}

                      </h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Supp. Ref. No. &nbsp;&nbsp;&nbsp;:</h5>
                  </td>
                  <td>
                    <h5>{data.reference_estimate || "N/A"}</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Against Form &nbsp;&nbsp;&nbsp;&nbsp;:</h5>
                  </td>
                  <td>
                    <h5>N/A</h5>
                  </td>
                </tr>
                <div className="divider"></div>
                <tr>
                  <td>
                    <strong>S.T.C. No. &nbsp;&nbsp;:</strong>
                  </td>
                  <td>{organization.stc_no}</td>
                </tr>
                <tr>
                  <td>
                    <strong>P.A.N. No. &nbsp;&nbsp;:</strong>
                  </td>
                  <td>{organization.pan_no}</td>
                </tr>
                <tr>
                  <td>
                    <strong>C.I.N. No. &nbsp;&nbsp;:</strong>
                  </td>
                  <td>{organization.cin_no}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="contact-box connected">
          <h5>To,&nbsp;&nbsp;&nbsp; {contact?.display_name}</h5>
        </div>

        {/* Order Items Table */}
        <table className="order-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Item Name / Description</th>
              <th>Quantity</th>
              <th>Unit</th>
              <th>Rate</th>
              <th>Disc.[%]</th>
              <th className="text-right">Amount</th>
            </tr>
          </thead>
          <tbody className="order-details-table">
            {order_item.map((item, index) => {
              const totalQuantity = item.expected_delivery_date_and_qty?.reduce(
                (total, schedule) => total + parseFloat(schedule.quantity),
                0
              )

              return (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    {item.product?.product_name || "N/A"}
                    <br />
                    <small>{item.description || "N/A"}</small>
                    <br />
                    <small>HSN/SAC No.: {item.hsn_code?.hsn_code || "N/A"}</small>
                    <br />
                    <small>Packing Type: {item.product?.packing_type || "N/A"}</small>
                    <br />
                    <small>Delivery Schedule:</small>{" "}
                    {item.expected_delivery_date_and_qty?.map((schedule, i) => (
                      <React.Fragment key={i}>
                        {i === 0 ? (
                          <small style={{ display: "inline" }}>
                            {new Date(
                              schedule.expected_delivery_date
                            ).toLocaleDateString("en-GB")}
                            : {schedule.quantity}
                          </small>
                        ) : (
                          <div
                            className="delivery-schedule"
                            style={{ marginLeft: "7.0em" }}
                          >
                            {/* Subsequent entries on new lines */}
                            <small>
                              {new Date(
                                schedule.expected_delivery_date
                              ).toLocaleDateString("en-GB")}
                              : {schedule.quantity}
                            </small>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </td>
                  <td>{totalQuantity || "-"}</td>
                  <td>{item.unit?.unit_name || "-"}</td>
                  <td>{item.rate}</td>
                  <td>{item.discount_rate || "0"}</td>
                  <td className="text-right">
                    {Number.isNaN(parseFloat(item.amount))
                      ? "0.00" // Fallback if amount is not a number
                      : parseFloat(item.amount).toFixed(2)}
                  </td>
                </tr>
              )
            })}
          </tbody>

          <tbody className="border-top-foot">
            <tr>
              <td colspan="2" className="totals-column">
                <div className="totals-container">
                  <div className="totals">
                    <table className="tax-details">
                      <tbody>
                        <tr>
                          <strong>{totalQuantitySum}</strong>
                        </tr>
                        {Object.keys(taxes).map(rate => (
                          <React.Fragment key={rate}>
                            <tr>
                              <td>
                                <strong>SGST {rate / 2}%:</strong>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>CGST {rate / 2}%:</strong>
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
              <td colspan="8" className="charges-column">
                <div className="charges-totals-container">
                  <div className="charges-totals">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <h5 className="charging-label" style={{ fontFamily: 'Verdana, sans-serif', fontSize:"14px" }}>Basic Item</h5>
                          </td>
                          <td>{data?.subtotal}</td>
                        </tr>
                        {Object.keys(taxes).map(rate => (
                          <React.Fragment key={rate}>
                            <tr>
                              <td>
                                <strong className="basic-label">
                                  @ {rate / 2}% SGST :
                                </strong>
                              </td>
                              <td>{taxes[rate].sgst.toFixed(2)}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong className="basic-label">
                                  @ {rate / 2}% CGST :
                                </strong>
                              </td>
                              <td>{taxes[rate].cgst.toFixed(2)}</td>
                            </tr>
                          </React.Fragment>
                        ))}
                        {packaging_charges > 0 && (
                          <tr>
                            <td>
                              <strong className="charge-label">
                                Packaging Charges :
                              </strong>
                            </td>
                            <td>
                              {parseFloat(packaging_charges || 0).toFixed(2)}
                            </td>
                          </tr>
                        )}
                        {documentation_charges > 0 && (
                          <tr>
                            <td>
                              <strong className="charge-label">
                                Documentation Charges :
                              </strong>
                            </td>
                            <td>
                              {parseFloat(documentation_charges || 0).toFixed(
                                2
                              )}
                            </td>
                          </tr>
                        )}
                        {forwarding_charges > 0 && (
                          <tr>
                            <td>
                              <strong className="charge-label">
                                Forwarding Charges :
                              </strong>
                            </td>
                            <td>
                              {parseFloat(forwarding_charges || 0).toFixed(2)}
                            </td>
                          </tr>
                        )}
                        {freight_charges > 0 && (
                          <tr>
                            <td>
                              <strong className="charge-label">
                                Freight Charges :
                              </strong>
                            </td>
                            <td>
                              {parseFloat(freight_charges || 0).toFixed(2)}
                            </td>
                          </tr>
                        )}
                        {tds_amount > 0 && (
                          <tr>
                            <td>
                              <strong className="charges-label">
                                TDS : &nbsp;
                              </strong>
                            </td>
                            <td>{parseFloat(tds_amount || 0).toFixed(2)}</td>
                          </tr>
                        )}
                        {discount > 0 && (
                          <tr>
                            <td>
                              <strong className="charges-label">
                                Discount : &nbsp;
                              </strong>
                            </td>
                            <td>{parseFloat(discount || 0).toFixed(2)}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="7"> </td>
            </tr>
          </tfoot>
        </table>

        {/* Total Box with Total in Words */}
        <div className="total-box connected">
          <p className="total-in-words">
            <strong>Amt. in Words:&nbsp;</strong>
            {organization?.currency?.code}&nbsp;{numberToWords(data?.total ?? 0)}
          </p>
          <p className="total-amount">
           <strong>Net Total:</strong> {data?.total ?? 0}
          </p>

        </div>

        <div className="terms-conditions connected">
          <table className="terms-table">
            <thead>
              <tr>
                <th>Terms & Conditions (if Any):</th>
              </tr>
            </thead>
            <tbody>
              {data?.terms_and_conditions?.map((item, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>{item.dropdown}:</td>
                    <td>{item.text}</td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        <div className="indent-department connected">
          <table className="indent-table">
            <tbody>
              <tr>
                <td>
                  <strong>
                    Indent Department:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </strong>{" "}
                  STORES
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>F.O.R.:</strong> F.O.R.
                </td>
              </tr>
              <tr>
                <h5>Remarks: {data.customer_notes}</h5>
              </tr>
              <tr>
                <td colspan="2">
                  <strong className="roles">
                    Purchase Dept. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  </strong>{" "}
                  Finance Controller Plant Head
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "left" }}>
                  <strong>E. & O.E.</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <div className="signature">
                    <strong>L. R. KATRAT</strong>
                    <br />
                    MD & CEO
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <div className="page-number"></div> */}
        {/* Address directly below without a box */}
        <p className="address-text centered">{formattedAddress}</p>
      </div>
      <div className="page-number"></div>
    </div>
  )
}

export default PurchaseOrderPdf
